import { useEffect, useState } from "react";
import { Slider } from "antd";
import {
  RangeSliderBox,
  Dashboard,
  DashboardList,
  DashboardItem,
  ItemTitle,
  ItemNumber, 
  ReviewNoCounter,
  ReviewNoCounterSpan,
} from "./rangesliderStyle"; 
// import { Tooltip } from "react-bootstrap";

const RangeSlider = ({fundInfo}:any) => {
  const [value,setValue] = useState(0);
  useEffect(() => {
  if(fundInfo?.raised)
  {
    setValue((fundInfo?.raised*100)/fundInfo?.goal)
  }
  },[fundInfo])

  return (
    <>
      <RangeSliderBox>
        <Slider value={value}  defaultValue={30} tooltip={{ open: true, placement: 'top',formatter:(value) =>value+"%" }}
            />
        
      </RangeSliderBox>

      <Dashboard>
        <DashboardList className="rage-item">
          <DashboardItem>
            <ItemTitle>My Goal</ItemTitle>
            <ItemNumber>$ {fundInfo?.goal}</ItemNumber>
          </DashboardItem>
          <DashboardItem>
            <ItemTitle>Raised</ItemTitle>
            <ItemNumber>$ {fundInfo?.raised}</ItemNumber>
          </DashboardItem>
          <DashboardItem>
            <ItemTitle>Still Need</ItemTitle>
            <ItemNumber>$ {fundInfo?.remain}</ItemNumber>
          </DashboardItem>
        </DashboardList>

        <ReviewNoCounter className="review-no-counter">
          <ReviewNoCounterSpan>0</ReviewNoCounterSpan> Review
        </ReviewNoCounter>
        
      </Dashboard>
    </>
  );
};
export default RangeSlider;
